import Vue from 'vue'

import Notification from "./notification";
import User from "./user"
import Loading from "./loading"
import Alert from "./alert"

Vue.mixin(Notification)
Vue.mixin(User)
Vue.mixin(Loading)
Vue.mixin(Alert)
